import React, { useState, useEffect, useCallback } from "react";
import { Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { DataGrid } from "@mui/x-data-grid";
import { Action, DefaultPerPageValue, PerPage } from "../../constants/Common";
import Loader from "../../Components/Common/Loader";
import NodataFound from "../../Components/Common/NoDataFound";
import { Helmet } from "react-helmet";
import { getAllLegalDeliverableList, getDeliverableDocumentDetails } from "../../api/casp/deliverable";
import { withTranslation } from "react-i18next";
import Search from "../../Components/casp/common/Search";
import SearchDropDownListPaginationComponent from "../../Components/casp/common/SearchDropDownPaginationList";
import { getAllProject } from "../../api/casp/project";
import userImage from "../../assets/images/icons/ticket.png";
import { hasModulePermission } from "../../helpers/permission";
import { Modules } from "../../constants/Module";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { downloadDeliverableExcel, getProjectDeliverableDetails } from "../../api/casp/projectDeliverable";
import SubmitLegalDocument from "../../Components/ProjectSubmission/submitLegalDocument";
import { Tooltip } from '@mui/material';
import { getDownloadableLink } from "../../api/casp/document";
import { getAllPortfolios } from "../../api/casp/portfolio";
import { Role } from "../../constants/Role";
import { useSelector } from "react-redux";
const LegalDocuments = (props) => {
  const [documents, setDocuments] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(DefaultPerPageValue);
  const [rowCount, setRowCount] = useState(0);
  const [triggerData, setTriggerData] = useState(+new Date());
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [project, setProject] = useState();
  const [status, setStatus] = useState();
  const [searchedTerm, setSearchedTerm] = useState(null);
  const [filterData, setFilterData] = useState({
    filterFields: [],
    filterInputs: []
  });
  const location = useLocation();
  const highlightRow = location?.state?.moduleRelation
  // const [moduleName, setModuleName] = useState("");
  const [selectedDeliverable, setSelectedDeliverable] = useState();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [deliverableAction, setDeliverableAction] = useState(null);
  const hasViewProjectDeliverablePermission = hasModulePermission(Modules.DELIVERABLE, Action.VIEW) && hasModulePermission(Modules.PROJECT, Action.VIEW);
  const [portfolio,setPortfolio] = useState()
  const loggedInUser = useSelector((state) => state.Profile.user);

  const handleDownload = async (deliverableId, projectId, type) => {
    try {
      const response = await getDeliverableDocumentDetails(deliverableId, {
        projectId: projectId,
        type: type
      });
      const id = response.data.data[0].id;
      const result = await getDownloadableLink(id);
      window.open(result.data.data, '_blank');
    } catch (error) {
      console.error('Error downloading document:', error);
    }
  };

  const fetchDocumentDetails = async (deliverableId, projectId, type) => {
    try {
      const response = await getDeliverableDocumentDetails(deliverableId, {
        projectId: projectId,
        type: type
      });
      const id = response.data.data.length > 0 && response.data.data[0].id;
      const fileName = response.data.data.length > 0 && response.data.data[0].name;
      const storageLink = response.data.data.length > 0 && response.data.data[0].storageLink;
      return {
        id: id,
        fileName: fileName,
        storageLink: storageLink
      }
    } catch (error) {
      console.error('Error downloading document:', error);
    }
  };

  const handleLinkDownload = async (documentId) => {
    try {
      const result = await getDownloadableLink(documentId);
      if (result.statusCode === 200) {
        toast.success(result.data.message);
        window.open(result.data.data, '_blank');
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.error('Error downloading document:', error);
    }
  };

  const handleCloseDeliverableDrawer = (_, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    setDrawerOpen(false);
    setSelectedDeliverable();
    setDeliverableAction()
  };

  const columns = [
    {
      field: "projectName",
      headerName: props.t("Startup Name"),
      flex: 1,
      renderCell: (Params) => (
        <Tooltip title={Params.value}>
          <span style={{ cursor: 'pointer' }}>{Params.value}</span>
        </Tooltip>
      ),
    },
    // {
    //   field: "deliverableName",
    //   headerName: props.t("Deliverable Name"),
    //   flex: 1,
    // },
    {
      field: "crnName",
      headerName: props.t("CR Name"),
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value || '-'}>
          <div
            onClick={() => params.value !== '-' && handleDownload(params.row.deliverableId, params.row.projectId, 'CRN Name')}
            style={{
              cursor: params.value !== '-' ? 'pointer' : 'default',
              color: params.value !== '-' ? '#0077cc' : 'inherit'
            }}
          >
            {params.value || '-'}
          </div>
        </Tooltip>
      ),
    },
    {
      field: "crnNumber",
      headerName: props.t("CR Number"),
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value || '-'}>
          <div
            onClick={() => params.value !== '-' && handleDownload(params.row.deliverableId, params.row.projectId, 'CRN Number')}
            style={{
              cursor: params.value !== '-' ? 'pointer' : 'default',
              color: params.value !== '-' ? '#0077cc' : 'inherit'
            }}
          >
            {params.value || '-'}
          </div>
        </Tooltip>
      ),
    },
    {
      field: "iBanNumber",
      headerName: props.t("IBAN Number"),
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value || '-'}>
          <div
            onClick={() => params.value !== '-' && handleDownload(params.row.deliverableId, params.row.projectId, 'IBAN Certificate')}
            style={{
              cursor: params.value !== '-' ? 'pointer' : 'default',
              color: params.value !== '-' ? '#0077cc' : 'inherit'
            }}
          >
            {params.value || '-'}
          </div>
        </Tooltip>
      ),
    },
    {
      field: "bankName",
      headerName: props.t("Bank Name"),
      flex: 1
    },
    {
      field: "establishmentContractName",
      headerName: props.t("Article of Association"),
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value || '-'}>
          <div
            onClick={() => {
              params.value !== '-' && handleLinkDownload(params.row.establishmentContractId)
            }}
            style={{
              cursor: params.value !== '-' ? 'pointer' : 'default',
              color: params.value !== '-' ? '#0077cc' : 'inherit'
            }}
          >
            {params.value || '-'}
          </div>
        </Tooltip>
      ),
    },
    {
      field: "agreementDocFileName",
      headerName: props.t("MISA Agreement"),
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value || '-'}>
          <div
            onClick={() => params.value !== '-' && handleLinkDownload(params.row.agreementDocFileId)}
            style={{
              cursor: params.value !== '-' ? 'pointer' : 'default',
              color: params.value !== '-' ? '#0077cc' : 'inherit'
            }}
          >
            {params.value || '-'}
          </div>
        </Tooltip>
      ),
    },
    {
      field: "currentStatus",
      headerName: props.t("Status"),
      flex: 1,
      renderCell: (params) => params.value ? props.t(params.value) : ""
    },
    {
      field: "action",
      headerName: props.t("Actions"),
      sortable: false,
      // width: 30,
      filterable: false,
      hideable: false,
      renderCell: (params) => {
        const fetchDeliverableDetails = async (deliverableId, projectId) => {
          try {
            const response = await getProjectDeliverableDetails(deliverableId, {
              projectId: projectId,
            });
            // setModuleName("Deliverable");
            setSelectedDeliverable(response.data.data);
            setDeliverableAction("View");
            setDrawerOpen(true);
          } catch (error) {
            console.error("Error fetching deliverable details:", error);
            toast.error("Failed to fetch deliverable details");
          }
        };

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              height: "100%",
              backgroundColor:
                highlightRow?.id === params.row?.id ? "#cce6ff" : "",
              padding: "0 10px",
            }}
          >
            <button
              onClick={() => {
                const projectId = params.row.projectId;
                fetchDeliverableDetails(params.row.id, projectId);
              }}
              style={{
                cursor: "pointer",
                color: "blue",
                textDecoration: "underline",
                background: "none",
                border: "none",
                padding: 0,
                font: "inherit",
              }}
              className="MuiDataGrid-cellContent"
            >
              <RemoveRedEyeOutlinedIcon />
            </button>
          </div>
        );
      },
    },
  ];

  const fetchDocuments = useCallback(async () => {
    try {
      setIsLoading(true);
      const params = {
        ...filterData,
        page: page + 1,
        perPage: rowsPerPage,
        ...(search && { search }),
      };
      const response = await getAllLegalDeliverableList(params);
      const { data, meta } = response.data.data;

      const formattedData = await Promise.all(data.map(async (doc) => {
        const establishmentContract = await fetchDocumentDetails(doc.deliverable.id, doc.project.id, 'Establishmnent Contract');
        const agreementDocFile = await fetchDocumentDetails(doc.deliverable.id, doc.project.id, 'Agreement Document');
        return {
          id: doc.id,
          projectId: doc.project.id,
          uniqueProjectId: doc.project.uniqueProjectId,
          projectName: doc.project.name,
          deliverableName: doc.deliverable.name,
          deliverableId: doc.deliverable.id,
          crnName: doc.crnName || '-',
          crnNumber: doc.crnNumber || '-',
          iBanNumber: doc.iBanNumber || '-',
          bankName: doc.bankName || '-',
          establishmentContractId: establishmentContract?.id || '-',
          establishmentContractName: establishmentContract?.fileName || '-',
          establishmentContractLink: establishmentContract?.storageLink || '-',
          agreementDocFileId: agreementDocFile?.id || '-',
          agreementDocFileName: agreementDocFile?.fileName || '-',
          agreementDocFileLink: agreementDocFile?.storageLink || '-',
          currentStatus: doc.currentStatus,
        };
      }));
      setDocuments(formattedData);
      setRowCount(meta.total);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [page, rowsPerPage, filterData, search]);

  // Global Search
  const globalSearch = async (params) => {
    setSearch(params.search);
    await fetchDocuments();
  };

  useEffect(() => {
    fetchDocuments();
  }, [fetchDocuments, triggerData]);

  const deliverableRefresh = async () => {
    setTriggerData(+new Date());
  };

  // download csv
  // const downloadCsv = async () => {
  //   try {
  //     const response = await downloadDeliverableCSV();

  //     // Create a Blob from the CSV string
  //     const blob = new Blob([response], { type: 'text/csv;charset=utf-8;' });

  //     // Create a temporary link to trigger the download
  //     const url = URL.createObjectURL(blob);
  //     const link = document.createElement('a');
  //     link.href = url;
  //     link.setAttribute('download', 'deliverables.csv'); // Customize filename as needed
  //     document.body.appendChild(link);
  //     link.click();

  //     // Cleanup
  //     document.body.removeChild(link);
  //     URL.revokeObjectURL(url);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }

  // download excel
  const downloadExcel = async () => {
    try {
      const response = await downloadDeliverableExcel(); // This will be arrayBuffer

      const blob = new Blob([response], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'deliverables.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Helmet>
            <title>{props.t("Legal Documents")} | NTDP</title>
          </Helmet>
          <div className="d-flex justify-content-between align-items-center">
            <div className="mainPageHeader d-flex justify-content-between">
              <BreadCrumb title={props.t("Legal Documents")} pageTitle={props.t("Documents")} />
            </div>
            <div className="d-flex justify-content-end ongoingSearchField align-items-center">
              {
                hasViewProjectDeliverablePermission && (
                  <>
                    <button
                      className="edit_button d-flex justify-content-center px-3 mx-2"
                      onClick={downloadExcel}
                    >
                      <p className="mb-0">{props.t("Download Excel")}</p>
                    </button>
                  </>
                )
              }
              {/* <div className="me-2">
                <Autocomplete
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={status}
                  size="small"
                  sx={{ width: "200px" }}
                  options={Object.values(DeliverableStatus).map(statusValue => ({
                    value: statusValue,
                    label: props.t(statusValue)
                  }))}
                  onChange={(_, item) => {
                    setStatus(item);
                    const newFilterData = {
                      filterFields: [],
                      filterInputs: []
                    };

                    // Add project filter if it exists
                    if (project) {
                      newFilterData.filterFields.push("projectName");
                      newFilterData.filterInputs.push(project.name);
                    }

                    // Add status filter if selected
                    if (item) {
                      newFilterData.filterFields.push("currentStatus");
                      newFilterData.filterInputs.push(item.value);
                    }

                    setFilterData(newFilterData);
                    setTriggerData(+new Date());
                  }}
                  renderInput={(params) => <TextField {...params}
                    label={props.t("Status")}
                  />}
                />
              </div> */}
              <div className="me-2">
                <SearchDropDownListPaginationComponent
                  label={props.t("Cohort")}
                  sx={{
                  width: 200,
                  }}
                  searchEnabled={false}
                  listCall={getAllPortfolios}
                  disableClearable={!portfolio}
                  defaultValue={portfolio}
                  apiParams={{
                      order: "updatedAt",
                      direction: "desc",
                      ...(![
                          Role.PROJECT_MANAGER,
                          Role.EPMO_MANAGER,
                          Role.ROOT_ADMIN,
                          Role.VICE_PRESIDENT,
                          Role.PRESIDENT,
                          Role.PROGRAM_MANAGER,
                          Role.EPMO_OFFICER,
                          Role.MENTOR
                      ].includes(loggedInUser?.role?.name) && {
                          filterFields: "portfolioUser",
                          filterInputs: loggedInUser.id,
                      }),
                  }}
                  emitItem={(newValue) => {
                      setPortfolio(newValue);
                      const newFilterData = {
                      filterFields: [],
                      filterInputs: []
                    };

                    // Add project filter if selected
                    if (project) {
                      newFilterData.filterFields.push("projectName");
                      newFilterData.filterInputs.push(project.name);
                    }
                    // Maintain status filter if it exists
                    if (status) {
                      newFilterData.filterFields.push("currentStatus");
                      newFilterData.filterInputs.push(status.value);
                    }

                    if(newValue){
                      newFilterData.filterFields.push("portfolio");
                      newFilterData.filterInputs.push(newValue.id);
                    }
                      setFilterData(newFilterData);
                      setPage(0)
                      setTriggerData(+new Date());
                  }}
                />
                </div>
                <div className="me-2">
                <SearchDropDownListPaginationComponent
                  label={props.t("Startup Name")}
                  searchEnabled={false}
                  disableClearable={!project}
                  listCall={getAllProject}
                  defaultValue={project}
                  size="small"
                  sx={{ width: "200px" }}
                  emitItem={(newValue) => {
                    setProject(newValue);
                    const newFilterData = {
                      filterFields: [],
                      filterInputs: []
                    };

                    // Maintain status filter if it exists
                    if (status) {
                      newFilterData.filterFields.push("currentStatus");
                      newFilterData.filterInputs.push(status.value);
                    }

                    // Add project filter if selected
                    if (newValue) {
                      newFilterData.filterFields.push("projectName");
                      newFilterData.filterInputs.push(newValue.name);
                    }

                    // Add cohort filter if selected
                    if(portfolio){
                      newFilterData.filterFields.push("portfolio");
                      newFilterData.filterInputs.push(portfolio.id);
                    }

                    setFilterData(newFilterData);
                    setTriggerData(+new Date());
                  }}
                  // apiParams={searchedTerm && searchedTerm !== "undefined" ? {
                  //   filterFields: ["name", "status"],
                  //   filterInputs: [searchedTerm, ProjectStatuses.ONGOING]
                  // } : {
                  //   filterFields: ["status"],
                  //   filterInputs: [ProjectStatuses.ONGOING]
                  // }}
                  apiParams={searchedTerm && searchedTerm !== "undefined" ? {
                    filterFields: ["name"],
                    filterInputs: [searchedTerm]
                  } : {
                    filterFields: [],
                    filterInputs: []
                  }}
                  handleInputChange={(data) => setSearchedTerm(data)}
                />
              </div>
              <div className="position-relative">
                <Search
                  listCall={globalSearch}
                  params={{
                    page: 1,
                    perPage: rowsPerPage,
                  }}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div style={{ width: '100%' }}>
                    {!isLoading ? (
                      documents.length ? (
                        <DataGrid
                          sx={{
                            '& .MuiDataGrid-virtualScroller': {
                              overflowX: 'auto',  // enable horizontal scroll only on rows
                              minWidth: `${columns.length * 150}px`,
                            },
                          }}
                          rows={documents}
                          columns={columns}
                          // pageSize={rowsPerPage}
                          // page={page}
                          rowCount={rowCount}
                          // onPageChange={(newPage) => setPage(newPage)}
                          // onPageSizeChange={(newPageSize) => setRowsPerPage(newPageSize)}
                          pagination
                          paginationModel={{ page: page, pageSize: rowsPerPage }}
                          onPaginationModelChange={(newModel) => {
                            setPage(newModel.page);
                            setRowsPerPage(newModel.pageSize);
                          }}
                          paginationMode="server"
                          disableSelectionOnClick
                          disableColumnMenu
                          autoHeight
                          pageSizeOptions={PerPage}
                          getRowId={(row) => row.id}
                          localeText={{
                            noRowsLabel: props.t("No rows"),
                            MuiTablePagination: {
                              labelRowsPerPage: props.t("Rows per page:"),
                            },
                          }}
                        />
                      ) : (
                        <NodataFound text={props.t("No documents to show")} icon={userImage} />
                      )
                    ) : (
                      <Loader />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
      {drawerOpen && selectedDeliverable && (
        <SubmitLegalDocument
          isOpen={drawerOpen}
          handleClose={handleCloseDeliverableDrawer}
          selectedRow={selectedDeliverable}
          refresh={deliverableRefresh}
          isDisabled={true}
          action={deliverableAction}
        />
      )}
    </React.Fragment>
  );
};

export default withTranslation()(LegalDocuments);
